// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"260": "ec5c5937","7198": "2c5f5214","804": "6166aec1",}[chunkId] + ".css"
}